import { StringParam, useQueryParams } from "use-query-params";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { Tabs } from "@design-system/Tabs/Tabs";
import styles from "./FixedAssetsPage.module.scss";

const FIXED_ASSETS_TABS = {
    policies: "policies",
    register: "register",
} as const;

type FixedAssetsTab =
    (typeof FIXED_ASSETS_TABS)[keyof typeof FIXED_ASSETS_TABS];

function isFixedAssetsTab(
    value: string | null | undefined,
): value is FixedAssetsTab {
    return (
        value === FIXED_ASSETS_TABS.policies ||
        value === FIXED_ASSETS_TABS.register
    );
}

export const FixedAssetsPage: React.FC = () => {
    const [{ tab }, setQueryParams] = useQueryParams({ tab: StringParam });
    const activeTab = isFixedAssetsTab(tab) ? tab : FIXED_ASSETS_TABS.register;

    return (
        <div className={styles.page}>
            <Tabs.Root
                value={activeTab}
                onValueChange={(value) => {
                    if (isFixedAssetsTab(value)) {
                        setQueryParams({ tab: value }, "replaceIn");
                    }
                }}
            >
                <Tabs.List className={styles.tabsList}>
                    <Tabs.Tab value={FIXED_ASSETS_TABS.policies}>
                        Policies
                    </Tabs.Tab>
                    <Tabs.Tab value={FIXED_ASSETS_TABS.register}>
                        Register
                    </Tabs.Tab>
                </Tabs.List>
            </Tabs.Root>
            {activeTab === FIXED_ASSETS_TABS.policies ? (
                <EmptyState
                    header="No policies yet"
                    body="Policies set how assets depreciate on each ledger and which accounts they post to."
                />
            ) : (
                <EmptyState
                    header="No assets yet"
                    body="Add assets to record their depreciation/amortization on every ledger."
                />
            )}
        </div>
    );
};
